// GENERATED by scripts/build-icons.mjs from icons/rows-4.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const Rows4 = createIcon('rows-4', [
  ['rect', { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
  ['path', { d: "M21 7.5H3" }],
  ['path', { d: "M21 12H3" }],
  ['path', { d: "M21 16.5H3" }],
])
